import { LoadingButton } from '@mui/lab'
import { Autocomplete, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, ImageList, ImageListItem, ImageListItemBar, TextField, Typography, useMediaQuery } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { getProfile } from '../../../reducer/profileSlice';
import { useDispatch, useSelector } from 'react-redux';
import CustomDatePicker from '../ComponentReuse/CustomDatePicker';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import dayjs from 'dayjs';
import { getActivityConfig } from '../../../reducer/activityConfigSlice';
import ResponseDialog from '../ComponentReuse/ResponseDialog';
import { setActivityActive } from '../../../reducer/activityActiveSlice';
import { setEOCHistory } from '../../../reducer/eocHistorySlice';
import { getWeekOfYear } from '../../../function/WOY';

function EditActivity({ open, setOpen, dataActivity, setCloseEdit }) {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const profile = useSelector(getProfile);
    const activityConfig = useSelector(getActivityConfig);
    const [activityName, setActivityName] = useState([]);
    const [activityDate, setActivityDate] = useState(null);
    const [activityDes, setActivityDes] = useState("");
    const [image, setImage] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [fullWidth, setFullWidth] = useState(true);
    const [status, setStatus] = useState("");
    const [modalResponse, setModalResponse] = useState(false);
    const [eocReason, setEocReason] = useState("");
    const [success, setSuccess] = useState(false);

    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only('sm'));
    const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.only('md'));
    const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));

    useEffect(() => {
        if (dataActivity && open) {
            setActivityName(dataActivity?.activity);
            const date = startEOC();
            setActivityDate(date);
            setActivityDes(dataActivity?.description);
            setImage(dataActivity?.image_link);
            setEocReason(dataActivity?.remark);
            setLoading(false);
        }
    }, [dataActivity, open])

    const getCols = () => {
        if (isSmallScreen) return 2; // สำหรับหน้าจอ sm
        if (isMediumScreen) return 3; // สำหรับหน้าจอ md
        if (isLargeScreen) return 4; // สำหรับหน้าจอ lg ขึ้นไป
        return 1; // สำหรับหน้าจอขนาดเล็กกว่า sm
    };

    const handleClose = () => {
        setActivityName([]);
        setActivityDate(null);
        setActivityDes("");
        setImage([]);
        setEocReason("");
        setHoveredIndex(null);
        setStatus("");
        setSuccess(false);
        setOpen(false);
    };

    const getEOCDataTitle = () => {
        let data = {
            org_level_WO: "ระดับ",
            org_level: "กิจกรรมระหว่างเปิด EOC ระดับ"
        };
        if (dataActivity?.ep_timestamp !== undefined) {

            if (dataActivity?.org_level === "01") {
                data.org_level_WO += "ประเทศ " + dataActivity?.org_name;
            } else if (dataActivity?.org_level === "02") {
                data.org_level_WO += "เขต " + dataActivity?.org_name;
            } else if (dataActivity?.org_level === "03") {
                data.org_level_WO += "จังหวัด " + dataActivity?.province_name;
            } else if (dataActivity?.org_level === "04") {
                data.org_level_WO +=
                    "อำเภอ " +
                    dataActivity?.amphur_name +
                    " จังหวัด" +
                    dataActivity?.province_name;
            }
            return data.org_level_WO;
        } else {
            if (dataActivity?.org_level === "01") {
                data.org_level += "ประเทศ " + dataActivity?.org_name;
            } else if (dataActivity?.org_level === "02") {
                data.org_level += "เขต " + dataActivity?.org_name;
            } else if (dataActivity?.org_level === "03") {
                data.org_level += "จังหวัด " + profile?.province_name;
            } else if (dataActivity?.org_level === "04") {
                data.org_level +=
                    "อำเภอ " +
                    profile?.amphur_name +
                    " จังหวัด" +
                    profile?.province_name;
            }
            return data.org_level;
        }
    };

    const startEOC = () => {
        let timeStamp = {};
        if (dataActivity?.ep_timestamp !== undefined) {
            timeStamp = dataActivity?.ep_timestamp;
        } else {
            timeStamp = dataActivity?.create_timestamp;
        }
        const date = new Date(parseInt(timeStamp));
        const startDate = dayjs(date);
        return startDate;
    };

    const handleDate = (value) => {
        if (value) {
            setActivityDate(value.valueOf());
        }
    };

    const handleActivityDes = (e) => {
        setActivityDes(e.target.value);
    };

    const resizeImage = (image, targetWidth, targetHeight) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = image;
            img.onload = () => {
                let width = img.width;
                let height = img.height;
                let scale = 1;
                if (width > targetWidth || height > targetHeight) {
                    const scaleWidth = targetWidth / width;
                    const scaleHeight = targetHeight / height;
                    scale = Math.min(scaleWidth, scaleHeight);
                }

                width *= scale;
                height *= scale;

                // create image with canvas 720 p
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                // return as base 64
                resolve(canvas.toDataURL("image/png"));
            };
        });
    };

    const handleImage = async (e) => {
        const img = e.target.files;
        const imgList = [];
        if (img.length + image.length <= 20) {
            for (let index = 0; index < img.length; index++) {
                const element = img[index];
                if ((element && element.type === 'image/png') || (element && element.type === 'image/jpg') || (element && element.type === 'image/jpeg')) {
                    const imgDataUrl = await resizeImage(
                        URL.createObjectURL(element),
                        1280,
                        720
                    );
                    imgList.push(imgDataUrl);
                } else {
                    setStatus("กรุณาเลือกไฟล์ที่มีนามสกุล .png และ .jpg เท่านั้น")
                    setModalResponse(true)
                    break;
                }
            }
            setImage((prev) => {
                return [...prev, ...imgList];
            });
        } else {
            setStatus("คุณใส่รูปเกินที่กำหนด");
            setModalResponse(true);
        }
    };

    const onDeleteImage = async (index) => {
        let newImage = [...image];
        newImage.splice(index, 1);
        setImage(newImage);
    };

    const callMyEOCData = async () => {
        try {
            let param = "";
            if (profile?.org_level === "02") {
                param = `org_id=${profile?.org_id}`;
            } else {
                param = `area_code=${profile?.area_code}`;
            }
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/my_eoc/get_eoc/${profile?.org_level}?${param}`
            );
            const data = await response.json();
            if (data.history_eoc.length !== 0) {
                dispatch(setEOCHistory(data?.history_eoc.reverse()));
            } else {
                dispatch(setEOCHistory(undefined));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const callActivityData = async (eoc_id) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/my_eoc/get_activity/${eoc_id}`
            );
            const data = await response.json();
            if (data.length !== 0) {
                dispatch(setActivityActive(data));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleCloseResponse = () => {

        setModalResponse(false);
        if (success) {
            if (eocReason !== undefined && eocReason !== "") {
                callMyEOCData();
                setCloseEdit(false);
            } else {
                callActivityData(dataActivity.eoc_id);
            }
            setActivityName([]);
            setActivityDate(null);
            setActivityDes("");
            setImage([]);
            setEocReason("");
            setHoveredIndex(null);
            setStatus("");
            setSuccess(false);
            setOpen(false);
        }
    };

    const handleNotEOC = (e) => {
        setEocReason(e.target.value);
    };

    const getWOY = () => {
        let woy = { week: "", year: "" };
        let getWOY = getWeekOfYear(dayjs(activityDate).toDate());
        woy.week = getWOY.week;
        woy.year = getWOY.year;
        return woy;
    };

    const handleManageImage = async () => {
        let image_link = [];
        let deleteList = [...dataActivity.image_link];
        for (let index = 0; index < image.length; index++) {
            const element = image[index];
            let indexSearchDelete = deleteList.indexOf(element);
            if (image[index].indexOf("data:image/png;base64") === 0) {
                const imageBase64 = element.replace("data:image/png;base64,", "");
                const optionImageUpload = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ base64data: imageBase64 }),
                };
                const uploadResponse = await fetch(
                    `${process.env.REACT_APP_API_URL}/my_eoc/upload_img_base64`,
                    optionImageUpload
                );
                const data = await uploadResponse.json();
                image_link.push(data.image.file);
            } else {
                if (indexSearchDelete !== -1) {
                    deleteList.splice(indexSearchDelete, 1);
                    image_link.push(element);
                }
            }
        }
        if (deleteList.length !== 0) {
            await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/remove_img`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(deleteList),
            });
        }
        return image_link;
    };

    const handleSubmit = async () => {
        setLoading(true);
        if (dataActivity?.ep_timestamp !== undefined) {
            try {
                if (
                    activityName.length !== 0 &&
                    eocReason.length !== 0 &&
                    activityDes.length !== 0 &&
                    (activityDate !== undefined || activityDate !== null)
                ) {
                    const image_link = await handleManageImage();
                    let dataSend = {
                        wo_eoc_id: dataActivity?.wo_eoc_id,
                        ep_timestamp: new Date(activityDate).getTime(),
                        ep_week: getWOY().week,
                        ep_year: getWOY().year,
                        activity: activityName,
                        description: activityDes,
                        image_link: image_link,
                        creator_id: dataActivity?.creator_id,
                        creator_name: dataActivity?.creator_name,
                        province_code: dataActivity?.province_code,
                        province_name: dataActivity?.province_name,
                        amphur_code: dataActivity?.amphur_code,
                        amphur_name: dataActivity?.amphur_name,
                        tambon_code: dataActivity?.tambon_code,
                        tambon_name: dataActivity?.tambon_name,
                        area_code: dataActivity?.area_code,
                        org_id: profile?.org_id,
                        org_name: profile?.org_name,
                        org_type: profile?.org_type,
                        org_type_name: profile?.org_type_name,
                        org_level: profile?.org_level,
                        org_level_name: profile?.org_level_name,
                        phone: profile?.telephone,
                        email: profile?.mail,
                        remark: eocReason,
                    };
                    const response = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/update_activity_wo_eoc`, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(dataSend),
                    });
                    if (response.ok) {
                        setSuccess(true);
                        setStatus("ทำการแก้ไข รายงานการดำเนินการตอบโต้ภาวะฉุกเฉิน โดยไม่เปิดEOC เสร็จสิ้น")
                        setModalResponse(true);
                        setOpen(false);
                        setLoading(false);
                    } else {
                        setSuccess(false);
                        setStatus("ไม่สามารถแก้ไข รายงานการดำเนินการตอบโต้ภาวะฉุกเฉิน โดยไม่เปิดEOC ได้")
                        setModalResponse(true);
                        setLoading(false);
                    }
                } else {
                    let request = "";
                    if (eocReason.length === 0) {
                        request += "เหตุผล ";
                    }
                    if (activityName.length === 0) {
                        request += "ชื่อกิจกรรม ";
                    }
                    if (activityDate === undefined || activityDate === null) {
                        request += "วันที่ ";
                    }
                    if (activityDes.length === 0) {
                        request += "รายละเอียดกิจกรรม ";
                    }
                    setSuccess(false);
                    setStatus("ใส่ข้อมูล " + request + "ไม่ครบ");
                    setModalResponse(true);
                    setLoading(false);
                }
            } catch (error) {
                console.log(error)
                setSuccess(false);
                setStatus("ไม่พบการแก้ไขรายงานการดำเนินกิจกรรมตอบโต้ภาวะฉุกเฉิน โดยไม่เปิด EOC");
                setModalResponse(true);
                setLoading(false);
            }

        } else {
            try {
                if (
                    activityName.length !== 0 &&
                    activityDes.length !== 0 &&
                    (activityDate !== undefined || activityDate !== null)
                ) {
                    const image_link = await handleManageImage();
                    let dataSend = {
                        eoc_id: dataActivity?.eoc_id,
                        description: activityDes,
                        image_link: image_link,
                        creator_id: dataActivity?.creator_id,
                        creator_name: dataActivity?.creator_name,
                        org_id: profile?.org_id,
                        org_name: profile?.org_name,
                        org_type: profile?.org_type,
                        org_type_name: profile?.org_type_name,
                        org_level: profile?.org_level,
                        org_level_name: profile?.org_level_name,
                        activity_id: dataActivity?.activity_id,
                        activity: activityName,
                        create_timestamp: new Date(activityDate).getTime(),
                        phone: profile?.telephone,
                        email: profile?.mail,
                    };
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}/my_eoc/update_activity`,
                        {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(dataSend),
                        }
                    );
                    if (response.ok) {
                        setSuccess(true);
                        setLoading(false);
                        setStatus("ทำการแก้ไข กิจกรรม EOC เสร็จสิ้น");
                        setModalResponse(true);
                    } else {
                        setSuccess(false);
                        setLoading(false);
                        setStatus("ไม่สามารถแก้ไข กิจกรรม EOC ได้");
                        setModalResponse(true);
                    }
                } else {
                    let request = "";
                    if (activityName.length === 0) {
                        request += "ชื่อกิจกรรม";
                    }
                    if (activityDes.length === 0) {
                        request += "รายละเอียดกิจกรรม";
                    }
                    if (activityDate === undefined || activityDate === null) {
                        request += "วันที่";
                    }
                    setSuccess(false);
                    setLoading(false);
                    setStatus("ใส่ข้อมูล " + request + " ไม่ครบ");
                    setModalResponse(true);
                }
            } catch (error) {
                console.error(error);
                setSuccess(false);
                setStatus("ไม่พบการแก้ไขกิจกรรม");
                setLoading(false);
                setModalResponse(true);
            }
        }
    };

    return (
        <Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={open}
            >
                <DialogTitle className='py-3'>
                    <div>
                        {dataActivity?.ep_timestamp !== undefined ? (
                            <Typography variant="body1">
                                แก้ไขรายงานการดำเนินกิจกรรมตอบโต้ภาวะฉุกเฉิน โดยไม่เปิด EOC
                            </Typography>
                        ) : (
                            <Typography variant="body1">แก้ไขกิจกรรมระหว่างเปิด EOC</Typography>
                        )}
                        <Typography variant="body2">
                            {getEOCDataTitle()}
                        </Typography>
                    </div>
                </DialogTitle>
                <DialogContent className='md:px-16' dividers>
                    <div className="w-full items-center mt-4 mb-4 grid gap-2 xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-10">
                        {dataActivity?.ep_timestamp !== undefined ? (
                            <>
                                <Typography className="col-span-1 w-full">เหตุผลที่ไม่เปิด EOC</Typography>
                                <div className="col-span-9 w-full">
                                    <TextField
                                        id="outlined-size-small"
                                        size="small"
                                        fullWidth
                                        value={eocReason}
                                        onChange={handleNotEOC}
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                        <Typography className="col-span-1 w-full">
                            ชื่อกิจกรรม
                        </Typography>
                        <Autocomplete
                            multiple
                            fullWidth
                            className="col-span-9 w-full overflow-auto"
                            id="autocomplete-multiple-chips"
                            options={activityConfig?.config || []}
                            value={activityName}
                            getOptionLabel={(option) => option}
                            onChange={(event, newValue) => {
                                setActivityName(newValue);
                            }}
                            renderTags={(value, getTagProps) =>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        maxWidth: '100%',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {value.map((option, index) => (
                                        <Chip
                                            key={index}
                                            label={option}
                                            {...getTagProps({ index })}
                                        />
                                    ))}
                                </Box>
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    size="small"
                                    placeholder="เลือกกิจกรรม"
                                    className='w-full'
                                />
                            )}
                        />
                    </div>

                    <div className="w-full items-center mb-4 grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-10">
                        <Typography className="col-span-1 w-full">วันที่</Typography>
                        <div className="col-span-9 w-full items-center">
                            <CustomDatePicker
                                className='max-w-[300px]'
                                minDate={dataActivity !== undefined ? startEOC() : dayjs()}
                                value={activityDate}
                                onChange={handleDate}
                                slotProps={{
                                    textField: { size: "small", fullWidth }
                                }}
                            />
                        </div>
                    </div>

                    <div className="w-full items-center mb-4 grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-10">
                        <Typography className="col-span-1 w-full">รายละเอียด</Typography>
                        <div className="col-span-9 w-full">
                            <TextField
                                id="outlined-multiline-details"
                                label=""
                                fullWidth
                                multiline
                                rows={4}
                                value={activityDes}
                                onChange={handleActivityDes}
                            />
                        </div>
                    </div>

                    <div className="w-full items-center mb-4 grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-10">
                        <Typography className="col-span-1 w-full">ภาพกิจกรรม</Typography>
                        <div className="col-span-9 w-full flex items-center">
                            <Button
                                disabled={image?.length === 20 ? true : false}
                                variant="outlined"
                                size='small'
                                component="label"
                                style={{
                                    color: "#cd6c4a",
                                    borderColor: "#cd6c4a"
                                }}
                            >
                                เพิ่มรูปภาพกิจกรรม
                                <input type="file" accept=".png, .jpg, .jpeg" onChange={handleImage} multiple />
                            </Button>
                            <Typography variant="subtitle2" sx={{ marginLeft: "10px" }}>{image?.length}/20</Typography>
                        </div>
                    </div>

                    <div>
                        {image?.length > 0 ? (
                            <ImageList
                                sx={{
                                    width: '100%',
                                    overflow: 'hidden',
                                }}
                                cols={getCols()}
                                gap={8}
                            >

                                {image.map(((data, index) => {
                                    let src = `${process.env.REACT_APP_API_URL}/${data}`;
                                    if (data?.indexOf("data:image/png;base64") === 0) {
                                        src = data;
                                    }
                                    return (
                                        <ImageListItem
                                            key={index}
                                            onMouseEnter={() => setHoveredIndex(index)}
                                            onMouseLeave={() => setHoveredIndex(null)}
                                        >
                                            <img
                                                src={src}
                                                loading="lazy"
                                                className="w-full h-auto"
                                            />
                                            {hoveredIndex === index && (
                                                <ImageListItemBar
                                                    sx={{ height: '30px' }}
                                                    actionIcon={
                                                        <IconButton
                                                            className={
                                                                `absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ${hoveredIndex === index ? 'block' : 'hidden'}`
                                                            }
                                                            sx={{
                                                                color: 'rgba(255, 255, 255, 0.7)',
                                                                transition: '0.5s',
                                                            }}
                                                            aria-label={`delete`}
                                                            onClick={() => onDeleteImage(index)}
                                                        >
                                                            <DeleteForeverIcon />
                                                        </IconButton>
                                                    }
                                                />
                                            )}
                                        </ImageListItem>
                                    );
                                }))}
                            </ImageList>
                        ) : (
                            <Typography sx={{ mt: 2 }}>
                                ไม่มีรูปกิจกรรม
                            </Typography>
                        )}
                    </div>

                </DialogContent>
                <DialogActions className='mx-4 my-2 gap-[10px]'>
                    <LoadingButton
                        loading={loading}
                        onClick={handleSubmit}
                        variant="contained"
                        size='small'
                        style={{
                            backgroundColor: "#cd6c4a",
                        }}
                    >
                        แก้ไขกิจกรรม
                    </LoadingButton>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        size='small'
                        style={{
                            color: "#000",
                            borderColor: "#ccc",
                        }}
                    >
                        ปิด
                    </Button>
                </DialogActions>
            </Dialog>
            <ResponseDialog
                open={modalResponse}
                onClose={handleCloseResponse}
                dataResponse={status}
            />
        </Fragment>
    )
}

export default EditActivity